<swal
  #warnAlert
  title="Warning" i18n-title
  text="Are you sure you want to delete?" i18n-text
  icon="warning"
  [swalOptions]="swalOptions"
  (confirm)="deleteItem(identifier)">
</swal>
<button class="grid-delete icon-delete" *ngIf="showDelete"
  type="button"
  (keydown.enter)="prevent($event)"
  [disabled]="disabled" (click)="deleteClicked($event)">
  <mat-icon color="warn">delete</mat-icon>
</button>
